var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconRegenerate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 22,
    viewBox: "0 0 25 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.333496 11C0.333496 16.7983 5.03516 21.5 10.8335 21.5C13.6218 21.5 16.2935 20.4033 18.3002 18.4667L16.5502 16.7167C15.0685 18.2917 13.0035 19.1667 10.8335 19.1667C3.5535 19.1667 -0.0865035 10.37 5.0585 5.225C10.2035 0.0800004 19.0002 3.73167 19.0002 11H15.5002L20.1668 15.6667H20.2835L24.8335 11H21.3335C21.3335 5.20167 16.6318 0.5 10.8335 0.5C5.03516 0.5 0.333496 5.20167 0.333496 11Z",
    fill: "#878787"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRegenerate);
export default __webpack_public_path__ + "static/media/icon-regenerate.d160f2dedef760d5a51558798c2affe0.svg";
export { ForwardRef as ReactComponent };